import * as React from 'react';
import type { Dispatch, SetStateAction } from 'react';

import type {
  PaymentsCheckout_DlocalPaymentMethodType as DlocalPaymentMethod,
  Payments_TaxBehavior as TaxBehavior,
} from '__generated__/graphql-types';

import type CartsV2 from 'bundles/naptimejs/resources/carts.v2';
import type { PropsFromUseCart } from 'bundles/payments-common/data/useCart';
import type { PropsFromUsePartner } from 'bundles/payments-common/data/usePartner';
import type { PropsFromUsePromotionDiscounts } from 'bundles/payments-common/data/usePromotionDiscounts';
import type { OwnableProductsProp } from 'bundles/payments-common/data/useSubscriptionInfo';
import type { PropsFromUseValidPaymentProcessors } from 'bundles/payments-common/data/useValidPaymentProcessors';
import type { PropsFromUseWallets } from 'bundles/payments-common/data/useWallets';
import type { PropsFromUseGetCollectionForCourseraPlusCheckout } from 'bundles/payments-common/hooks/useGetCollectionForCourseraPlusCheckout';

export type TaxRateContextType = {
  taxRate: string;
  setTaxRate: Dispatch<SetStateAction<string>>;
  totalAmountWithTax: number;
  setTotalAmountWithTax: Dispatch<SetStateAction<number>>;
  taxBehavior: TaxBehavior;
  setTaxBehavior: Dispatch<SetStateAction<TaxBehavior>>;
};

export type CheckoutIntentType = {
  [key: string]: string | undefined;
};
export type CheckoutIntentContextType = {
  checkoutIntent: CheckoutIntentType;
  setCheckoutIntent: React.Dispatch<React.SetStateAction<CheckoutIntentType>>;
};

export type DlocalCheckoutDetailsType = {
  selectedPaymentMethod: DlocalPaymentMethod | null;
  payerEmail: string | null;
  payerPhone: string | null;
  payerDocument: string | null;
  hasValidationErrors: boolean;
  triggerValidation: () => void;
};
export type DlocalCheckoutDetailsContextType = {
  dlocalCheckoutDetails: DlocalCheckoutDetailsType;
  setDlocalCheckoutDetails: Dispatch<SetStateAction<DlocalCheckoutDetailsType>>;
};

export type PropsForUpdatingCart = {
  setCart: Dispatch<SetStateAction<CartsV2>>;
};

export type ContextType = PropsFromUseCart &
  PropsFromUsePromotionDiscounts &
  PropsFromUsePartner &
  PropsFromUseValidPaymentProcessors &
  PropsFromUseWallets &
  OwnableProductsProp &
  PropsFromUseGetCollectionForCourseraPlusCheckout &
  TaxRateContextType &
  CheckoutIntentContextType &
  DlocalCheckoutDetailsContextType &
  PropsForUpdatingCart;

const PageDataContext = React.createContext<ContextType | undefined>(undefined);

export default PageDataContext;
